import { render, staticRenderFns } from "./abnormalInfo.vue?vue&type=template&id=5c7d66cc&scoped=true&"
import script from "./abnormalInfo.vue?vue&type=script&lang=js&"
export * from "./abnormalInfo.vue?vue&type=script&lang=js&"
import style0 from "./abnormalInfo.vue?vue&type=style&index=0&id=5c7d66cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d66cc",
  null
  
)

export default component.exports